import { capitalize } from 'lodash';
import { getAuthCapabilities, getUserDataCapabilities } from '../redux/reducers/AuthReducer';
import Ability from './Ability';
import { TUPAY_INVALID_CAPABILITIES, userRoles } from './Constants';
import { isPanelType } from './panelUtils';
import { PanelType } from './Constants';

export class Capability {
  constructor(subject, action) {
    this.subject = subject;
    this.actions = action;
  }

  get action() {
    return this.actions;
  }
}

const twoPop = ['PAYMENT_METHODS', 'ALL_TRANSACTIONS'];
// /login
const login = new Capability('Login', 'execute');
// /balance
const balancesUsable = new Capability('Balances', 'view_usable');
const balancesSettleable = new Capability('Balances', 'view_settlable');
// /paymentmethods/summary
// /paymentmethods/status
const paymentMethodsSummary = new Capability('Paymentmethods', 'view_summary');

// /deposits
const cashInList = new Capability('Deposits', 'view_list');
// /deposits/{id}/resend
const cashInResendNotification = new Capability('Deposits', 'resend_notification');
// /deposits/{idDeposit}
const cashInViewDetails = new Capability('Deposits', 'view_detail_header');
// /deposits/{idDeposit}/history
const cashInViewDetailsHistory = new Capability('Deposits', 'view_detail_history');
// /deposits/{idDeposit}/flagForReview
const cashInFlagForReview = new Capability('Deposits', 'flag_review');
// /deposits/{idDeposit}/refund
// /{country}/accountTypes
const cashInManualRefund = new Capability('Deposits', 'manual_refund');
// /deposits/{idMerchant}/requestCashin
const cashInRequestManual = new Capability('Deposits', 'request_manual');

// /cashouts
const cashOutList = new Capability('Withdrawals', 'view_list');
// /cashouts/{id}/resend
// /cashouts/notify/{id}
const cashOutResendNotification = new Capability('Withdrawals', 'resend_notification');
// /cashouts/{idCashouts}
const cashOutViewDetails = new Capability('Withdrawals', 'view_detail_header');
// /cashouts/{idCashouts}/history
const cashOutViewDetailsHistory = new Capability('Withdrawals', 'view_detail_history');
// /cashouts/{idCashouts}/flagForReview
const cashOutFlagForReview = new Capability('Withdrawals', 'flag_review');
// /cashouts/{idCashouts}/requestReceipt
const cashOutRequestReceipt = new Capability('Withdrawals', 'request_receipt');
// /cashouts/{idMerchant}/requestCashout
const cashOutRequestManual = new Capability('Withdrawals', 'request_manual');

// /cashouts/{idTransaction}/changeStatus
// /cashouts/{idTransaction}/onHoldStatus
// /cashouts/cancel/{idTranscation}
const cashOutChangeStatus = new Capability('Withdrawals', 'change_status');
// cashout/cashoutBatch
// /cashouts/requestCashoutBatch
// /cashouts/cashoutBatch/{id}
const cashOutListBatch = new Capability('Withdrawals', 'view_batch');
const cashOutRequestBatch = new Capability('Withdrawals', 'request_batch');
const cashOutDownloadBatch = new Capability('Withdrawals', 'download_batch');

// /transactions
const allTransactionsList = new Capability('Alltransactions', 'view');

// /payment-orders
const paymentOrdersEnabled = new Capability('Paymentorders', 'management_enabled');
const paymentOrdersEnabledMerchant = new Capability('Payment', 'order_management_enabled');

// /notes
const notesList = new Capability('Note', 'view_list');
// /notes/addNote
const notesCreate = new Capability('Note', 'create');

// /notes/details/{idnote}
const noteViewDetails = new Capability('Note', 'view_details');

// /notes/{idnote}/flagForReview
const notesFlagForReview = new Capability('Note', 'flag_review');

// /refund
const refundList = new Capability('Refund', 'view_list');
const refundViewDetails = new Capability('Refund', 'view_details');
const refundCancel = new Capability('Refund', 'cancel');

// /chargeback
const chargebackList = new Capability('Chargeback', 'view_list');

// /report
const balanceReportList = new Capability('Balances', 'view_list');

// /export
const exportTransactions = new Capability('Export', 'data');

// /clients
const clientsList = new Capability('Client', 'view_list');
// /clients/{iduser}/details
const clientViewDetails = new Capability('Client', 'view_details');
// /clients/{iduser}/history
const clientViewHistory = new Capability('Client', 'view_history');
// /clients/{iduser}/statusChange
const clientStatusChange = new Capability('Client', 'status_ask_change');
// /clients/{iduser}/limitIncrease
const clientLimitIncrease = new Capability('Client', 'limits_ask_change');

// /cashouts/beneficiaries
const beneficiariesList = new Capability('Withdrawals', 'view_beneficiaries');
const beneficiaryViewDetails = new Capability('Withdrawals', 'view_beneficiary_details');
const beneficiaryModify = new Capability('Withdrawals', 'modify_beneficiaries');

// /recurringPayments
const recurringPaymentsList = new Capability('Withdrawals', 'view_list');
const recurringPaymentsViewDetails = new Capability('Withdrawals', 'view_recurring_payments_details');
const recurringPaymentsModify = new Capability('Withdrawals', 'modify_recurring_ayments');

// /paymentmethods
// /paymentmethods/description
const paymentMethodsList = new Capability('Paymentmethods', 'view');
const paymentMethodsStatus = new Capability('Paymentmethods', 'request_status');
// /messages
// /messages/description
const messageList = new Capability('Messages', 'recive');
// /settlements
const settlementsMerchant = new Capability('Settlement', 'merchant');
// /settlements
const settlementsHistory = new Capability('Settlement', 'view_list');
// /apd/settlements/availables
// const settlementsAvailables = new Capability('Settlement', 'view_availables');
// /apd/banks/savings
// /apd/settlements/fee
// /apd/settlements/create
const settlementsRequest = new Capability('Settlement', 'create');
// /apd/settlements/:idSettlement
const settlementViewDetail = new Capability('Settlement', 'view_detail');
// /apd/settlements/:idMerchant/scheduled
const settlementViewSchedule = new Capability('Settlement', 'view_scheduled');
const settlementUpdateSchedule = new Capability('Settlement', 'update_scheduled');
// approve/cancel settlement
const settlementAction = new Capability('Settlement', 'action');
// GET /merchants
const merchantsList = new Capability('Merchant', 'view_list');
// only to know how can do it
const merchantSettings = new Capability('Merchant', 'settings');
// only to know how can do it
const merchantSettingsEditBanksDetails = new Capability('Merchant', 'edit_bank_details');
const merchantSettingsEditBanksDetailsRoles = new Capability('Merchant', 'edit_bank_details_roles');
// GET /merchants/:idMerchant/company
const merchantSettingsViewCompany = new Capability('Merchant', 'view_company');
const merchantSettingsViewCompanyRoles = new Capability('Merchant', 'view_company_roles');
// POST /merchants/:idMerchant/company
// POST /merchants/:idMerchant/addLogo
// POST /merchants/:idMerchant/removeLogo
const merchantSettingsEditCompany = new Capability('Merchant', 'edit_company');
const merchantSettingsEditCompanyRoles = new Capability('Merchant', 'edit_company_roles');
// POST /merchants/:idMerchant/bankDetailsTicket
const merchantSettingsRequestChangeBank = new Capability('Merchant', 'request_change_bank_details');
// GET /merchants/:idMerchant/bankDetails
const merchantSettingsViewBankDetails = new Capability('Merchant', 'view_bank_details');
const merchantSettingsViewBankDetailsRoles = new Capability('Merchant', 'view_bank_details_roles');
// GET /merchants/:idMerchant/supportAddress
const merchantSettingsViewSupportAddress = new Capability('Merchant', 'view_address');
const merchantSettingsViewSupportAddressRoles = new Capability('Merchant', 'view_address_roles');
// POST /merchants/:idMerchant/supportAddress
const merchantSettingsEditSupportAddress = new Capability('Merchant', 'edit_address');
const merchantSettingsEditSupportAddressRoles = new Capability('Merchant', 'edit_address_roles');
// GET /merchants/:idMerchant/integrationDetails
const merchantSettingsViewIntegration = new Capability('Merchant', 'view_integration_details');
const merchantSettingsViewIntegrationRoles = new Capability('Merchant', 'view_integration_details_roles');
// POST /merchants/:idMerchant/integrationDetails
const merchantSettingsEditIntegration = new Capability('Merchant', 'edit_integration_details');
const merchantSettingsEditIntegrationRoles = new Capability('Merchant', 'edit_integration_details_roles');
// POST /merchants/:idMerchant/secretKey
const merchantSettingsViewSecretKey = new Capability('Merchant', 'view_secret_key');
const merchantSettingsViewSecretKeyRoles = new Capability('Merchant', 'view_secret_key_roles');

// GET /apd/balance/:idMerchant
const merchantSettingsViewBalanceRoles = new Capability('Merchant', 'view_balance_roles');
// GET /merchants/:idMerchant/generalConfig
// GET /merchants/:idMerchant/processingEntiety
// GET /merchants/:idMerchant/config
// GET /merchants/:idMerchant/configTier
// GET /merchants/:idMerchant/fxConfig
const merchantSettingsViewConfigRoles = new Capability('Merchant', 'view_config_roles');
// POST /merchants/:idMerchant/config
// POST /merchants/:idMerchant/configTier
// POST /merchants/:idMerchant/fxConfig
const merchantSettingsEditConfigRoles = new Capability('Merchant', 'edit_config_roles');
const merchantSettingsEditLimitsRoles = new Capability('Merchant', 'edit_limits_roles');
// POST /merchants/:idMerchant/editGeneralConfig
const merchantSettingsEditConfigGeneralRoles = new Capability('Merchant', 'edit_general_roles');
// POST /merchants/:idMerchant/editGeneralLegalConfig
const merchantSettingsEditConfigGeneralLegalRoles = new Capability('Merchant', 'edit_general_legal_roles');
// POST /merchants/:idMerchant/editGeneralCommercialConfig
const merchantSettingsEditConfigGeneralCommercialRoles = new Capability('Merchant', 'edit_general_commercial_roles');
// GET /merchants/:idMerchant/mailGroups
const merchantSettingsViewMailGroups = new Capability('Merchant', 'view_mail_groups');
// POST /merchants/:idMerchant/mailGroups
const merchantSettingsEditMailGroups = new Capability('Merchant', 'edit_mail_groups');
// GET /merchants/:idMerchant/ips
const merchantSettingsViewIps = new Capability('Merchant', 'view_ips');
// POST /merchants/:idMerchant/ips
const merchantSettingsEditIps = new Capability('Merchant', 'edit_ips');
// POST /merchants/:idMerchant/chargebackxFee
const merchantSettingsChargebackConfig = new Capability('Merchant', 'edit_chargebacks_fee');
// POST configurations/:idMerchant/installmentsConfig
// POST configurations/:idMerchant/releaseMode
// POST configurations/:idMerchant/releaseTime
// POST configurations/:idMerchant/anticipationRate
// POST configurations/:idMerchant/installmentsFee
// PUT configurations/:idMerchant/installmentsConfig
// PUT configurations/:idMerchant/releaseMode
// PUT configurations/:idMerchant/releaseTime
// PUT configurations/:idMerchant/anticipationRate
// PUT configurations/:idMerchant/installmentsFee
// DELETE configurations/:idMerchant/installmentsConfig/:country
// DELETE configurations/:idMerchant/releaseMode/:country
// DELETE configurations/:idMerchant/releaseTime/:country
// DELETE configurations/:idMerchant/anticipationRate
// DELETE configurations/:idMerchant/installmentsFee
const merchantSettingsCardPaymentConfigEdit = new Capability('Merchant', 'edit_card_payment_config');
// GET /signUp
const signUpRequestsList = new Capability('Signup', 'view_list');
// POST /signUp/:idRequest/changeStatus/:status
const signupUpdateStatus = new Capability('Signup', 'update_status');
const signupUpdateStatusCommercial = new Capability('Signup', 'update_status_commercial');
const signupUpdateStatusIt = new Capability('Signup', 'update_status_it');

// /users
const accountsList = new Capability('Users', 'list');
const accountsAdmin = new Capability('Users', 'admin');
// /users/create
// /users/edit
const accountCreate = new Capability('Users', 'edit');
const accountCreateAdmin = new Capability('Users', 'edit_admin');
const accountcommercialCanEditUsers = new Capability('Users', 'manage_admin');

// /tickets/createTicket
const createTicket = new Capability('Tickets', 'create');
// /tickets
const ticketsList = new Capability('Tickets', 'view_list');
// /tickets/{idTicket}
const ticketsDetails = new Capability('Tickets', 'view_detail');
// /tickets/{idTicket}/closeTicket
// /tickets/closeMultipleTickets
const ticketsClose = new Capability('Tickets', 'close');
export const voucherDownload = new Capability('Voucher', 'download');

const notificationsList = new Capability('Notifications', 'view_list');
const notificationsCreate = new Capability('Notifications', 'create');

const transferList = new Capability('Merchant', 'view_accounts');
const transferCreate = new Capability('Merchant', 'create_account');

// /commercialRelationship
// For now, we use another capability, change this when back-end is done.
const internalTransferList = new Capability('Deposits', 'view_list');

// /topUps
const topUpListMerchant = new Capability('Topup', 'merchant');
const topUpList = new Capability('Topup', 'view_list');
const topUpCreate = new Capability('Topup', 'create');

// upcoming payments
const upcomingPaymentsList = new Capability('Upcoming', 'view_payments');

// referrals
const referralReferredList = new Capability('Referral', 'view_list');
const referralEditFee = new Capability('Referral', 'create');

// authus
const authusView = new Capability('Authus', 'view');

// Rolling reserve
const rollingReserveView = new Capability('Rolling', 'reserve_view');

const adminAbilities = [
  login,
  paymentMethodsSummary,
  cashInList,
  cashInResendNotification,
  cashInViewDetails,
  cashInViewDetailsHistory,
  cashInManualRefund,
  cashOutList,
  cashOutResendNotification,
  cashOutViewDetails,
  cashOutViewDetailsHistory,
  cashOutChangeStatus,
  allTransactionsList,
  notesList,
  notesCreate,
  noteViewDetails,
  refundList,
  refundViewDetails,
  chargebackList,
  balanceReportList,
  clientsList,
  clientViewDetails,
  clientViewHistory,
  paymentMethodsList,
  paymentMethodsStatus,
  accountsAdmin,
  accountCreateAdmin,
  settlementsHistory,
  settlementAction,
  settlementViewDetail,
  settlementViewSchedule,
  settlementUpdateSchedule,
  merchantsList,
  merchantSettings,
  merchantSettingsViewCompanyRoles,
  merchantSettingsViewBankDetailsRoles,
  merchantSettingsViewSupportAddressRoles,
  merchantSettingsViewIntegrationRoles,
  merchantSettingsViewSecretKeyRoles,
  merchantSettingsEditCompanyRoles,
  merchantSettingsEditBanksDetailsRoles,
  merchantSettingsEditSupportAddressRoles,
  merchantSettingsEditIntegrationRoles,
  merchantSettingsViewBalanceRoles,
  merchantSettingsViewConfigRoles,
  merchantSettingsEditConfigRoles,
  merchantSettingsEditLimitsRoles,
  merchantSettingsEditConfigGeneralRoles,
  ticketsList,
  ticketsDetails,
  exportTransactions,
  merchantSettingsViewMailGroups,
  merchantSettingsEditMailGroups,
  signupUpdateStatus,
  signUpRequestsList,
  merchantSettingsViewIps,
  merchantSettingsEditIps,
  notificationsList,
  notificationsCreate,
  beneficiariesList,
  beneficiaryViewDetails,
  beneficiaryModify,
  cashOutListBatch,
  cashOutDownloadBatch,
  transferList,
  signupUpdateStatusIt,
  merchantSettingsChargebackConfig,
  topUpList,
  topUpCreate,
  internalTransferList,
  recurringPaymentsList,
  internalTransferList,
  upcomingPaymentsList,
  merchantSettingsCardPaymentConfigEdit,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

const commonRoles = [
  login,
  merchantsList,
  merchantSettings,
  merchantSettingsViewBalanceRoles,
  merchantSettingsViewCompanyRoles,
  merchantSettingsViewBankDetailsRoles,
  merchantSettingsViewSupportAddressRoles,
  merchantSettingsViewIntegrationRoles,
  exportTransactions,
  chargebackList,
  beneficiariesList,
  beneficiaryViewDetails,
  notificationsList,
  authusView,
  rollingReserveView,
];

const financeAbilities = [
  ...commonRoles,
  settlementsHistory,
  settlementViewDetail,
  settlementAction,
  settlementViewSchedule,
  settlementUpdateSchedule,
  notesList,
  noteViewDetails,
  notesCreate,
  merchantSettingsEditCompanyRoles,
  merchantSettingsViewConfigRoles,
  balanceReportList,
  transferList,
  paymentMethodsList,
  merchantSettingsEditConfigGeneralCommercialRoles,
  topUpList,
  topUpCreate,
  upcomingPaymentsList,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

const itAbilities = [
  ...commonRoles,
  cashInList,
  cashInViewDetails,
  cashInViewDetailsHistory,
  cashInResendNotification,
  cashOutList,
  cashOutViewDetails,
  cashOutViewDetailsHistory,
  cashOutResendNotification,
  cashOutChangeStatus,
  allTransactionsList,
  refundList,
  notesList,
  noteViewDetails,
  refundViewDetails,
  balanceReportList,
  paymentMethodsSummary,
  paymentMethodsList,
  paymentMethodsStatus,
  clientsList,
  clientViewDetails,
  clientViewHistory,
  settlementsHistory,
  settlementViewSchedule,
  ticketsList,
  ticketsDetails,
  accountsAdmin,
  accountCreateAdmin,
  merchantSettingsViewSecretKeyRoles,
  merchantSettingsEditCompanyRoles,
  merchantSettingsEditSupportAddressRoles,
  merchantSettingsEditIntegrationRoles,
  merchantSettingsViewConfigRoles,
  merchantSettingsEditConfigRoles,
  merchantSettingsEditLimitsRoles,
  merchantSettingsViewMailGroups,
  merchantSettingsEditMailGroups,
  signupUpdateStatus,
  signUpRequestsList,
  merchantSettingsViewIps,
  merchantSettingsEditIps,
  beneficiaryModify,
  cashOutListBatch,
  cashOutDownloadBatch,
  transferList,
  notificationsCreate,
  signupUpdateStatusIt,
  merchantSettingsChargebackConfig,
  internalTransferList,
  recurringPaymentsList,
  internalTransferList,
  merchantSettingsCardPaymentConfigEdit,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

const operationsAbilities = [
  ...commonRoles,
  cashInList,
  cashInResendNotification,
  cashInViewDetails,
  cashInViewDetailsHistory,
  cashInManualRefund,
  cashOutList,
  cashOutResendNotification,
  cashOutViewDetails,
  cashOutViewDetailsHistory,
  cashOutChangeStatus,
  allTransactionsList,
  refundList,
  notesList,
  noteViewDetails,
  refundViewDetails,
  balanceReportList,
  paymentMethodsSummary,
  paymentMethodsList,
  paymentMethodsStatus,
  clientsList,
  clientViewDetails,
  clientViewHistory,
  settlementsHistory,
  settlementViewDetail,
  settlementViewSchedule,
  ticketsList,
  ticketsDetails,
  merchantSettingsEditSupportAddressRoles,
  merchantSettingsViewConfigRoles,
  merchantSettingsViewIps,
  cashOutListBatch,
  cashOutDownloadBatch,
  notificationsCreate,
  topUpList,
  topUpCreate,
  internalTransferList,
  recurringPaymentsList,
  internalTransferList,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

const operationsAdminAbilities = [
  ...commonRoles,
  cashInList,
  cashInResendNotification,
  cashInViewDetails,
  cashInViewDetailsHistory,
  cashInManualRefund,
  cashOutList,
  cashOutResendNotification,
  cashOutViewDetails,
  cashOutChangeStatus,
  cashOutViewDetailsHistory,
  allTransactionsList,
  refundList,
  notesList,
  noteViewDetails,
  refundViewDetails,
  balanceReportList,
  paymentMethodsSummary,
  paymentMethodsList,
  paymentMethodsStatus,
  clientsList,
  clientViewDetails,
  clientViewHistory,
  settlementsHistory,
  settlementViewDetail,
  settlementViewSchedule,
  ticketsList,
  ticketsDetails,
  merchantSettingsEditSupportAddressRoles,
  merchantSettingsViewConfigRoles,
  merchantSettingsEditConfigRoles,
  merchantSettingsEditLimitsRoles,
  merchantSettingsEditConfigGeneralCommercialRoles,
  merchantSettingsViewIps,
  beneficiaryModify,
  cashOutListBatch,
  cashOutDownloadBatch,
  notificationsCreate,
  topUpList,
  topUpCreate,
  internalTransferList,
  recurringPaymentsList,
  internalTransferList,
  merchantSettingsCardPaymentConfigEdit,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

const commercialAbilities = [
  ...commonRoles,
  ...commonRoles,
  cashInList,
  cashInViewDetails,
  cashInViewDetailsHistory,
  cashOutList,
  cashOutViewDetails,
  cashOutViewDetailsHistory,
  allTransactionsList,
  refundList,
  refundViewDetails,
  balanceReportList,
  paymentMethodsList,
  beneficiariesList,
  beneficiaryViewDetails,
  beneficiaryModify,
  clientsList,
  clientViewDetails,
  clientViewHistory,
  ticketsList,
  ticketsDetails,
  settlementsHistory,
  settlementViewDetail,
  settlementViewSchedule,
  notesList,
  merchantSettingsEditCompanyRoles,
  merchantSettingsViewConfigRoles,
  merchantSettingsEditConfigRoles,
  merchantSettingsEditConfigGeneralCommercialRoles,
  signupUpdateStatusCommercial,
  signUpRequestsList,
  accountsAdmin,
  accountcommercialCanEditUsers,
  cashOutListBatch,
  cashOutDownloadBatch,
  merchantSettingsChargebackConfig,
  topUpList,
  topUpCreate,
  internalTransferList,
  upcomingPaymentsList,
  merchantSettingsCardPaymentConfigEdit,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

const legalAbilities = [
  ...commonRoles,
  clientsList,
  clientViewDetails,
  clientViewHistory,
  merchantSettingsEditCompanyRoles,
  merchantSettingsEditBanksDetailsRoles,
  merchantSettingsViewConfigRoles,
  merchantSettingsEditConfigGeneralLegalRoles,
];

const supportAbilities = [
  ...commonRoles,
  cashInList,
  cashInResendNotification,
  cashInViewDetails,
  cashInViewDetailsHistory,
  cashInManualRefund,
  cashOutList,
  cashOutResendNotification,
  cashOutViewDetails,
  cashOutViewDetailsHistory,
  cashOutChangeStatus,
  allTransactionsList,
  refundList,
  refundViewDetails,
  paymentMethodsSummary,
  paymentMethodsList,
  beneficiariesList,
  beneficiaryViewDetails,
  beneficiaryModify,
  clientViewDetails,
  clientViewHistory,
  clientsList,
  ticketsList,
  ticketsDetails,
  settlementsHistory,
  settlementViewDetail,
  paymentMethodsStatus,
  recurringPaymentsList,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

const supportAdminAbilities = [
  ...commonRoles,
  cashInList,
  cashInResendNotification,
  cashInViewDetails,
  cashInViewDetailsHistory,
  cashInManualRefund,
  cashOutList,
  cashOutResendNotification,
  cashOutViewDetails,
  cashOutViewDetailsHistory,
  cashOutChangeStatus,
  allTransactionsList,
  refundList,
  refundViewDetails,
  paymentMethodsSummary,
  paymentMethodsList,
  beneficiariesList,
  beneficiaryViewDetails,
  beneficiaryModify,
  clientViewDetails,
  clientViewHistory,
  clientsList,
  ticketsList,
  ticketsDetails,
  notificationsCreate,
  settlementsHistory,
  settlementViewDetail,
  accountsList,
  paymentMethodsStatus,
  merchantSettingsEditSupportAddressRoles,
  merchantSettingsEditLimitsRoles,
  merchantSettingsViewConfigRoles,
  settlementViewSchedule,
  settlementUpdateSchedule,
  recurringPaymentsList,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

const auditAbilities = [
  ...commonRoles,
  cashInList,
  cashInViewDetails,
  cashInViewDetailsHistory,
  cashOutList,
  cashOutViewDetails,
  cashOutViewDetailsHistory,
  allTransactionsList,
  refundList,
  refundViewDetails,
  settlementsHistory,
  settlementViewDetail,
  settlementViewSchedule,
  notesList,
  noteViewDetails,
  merchantSettingsViewConfigRoles,
  balanceReportList,
  transferList,
  recurringPaymentsList,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

const complianceAbilities = [
  ...commonRoles,
  cashInList,
  cashInViewDetails,
  cashInViewDetailsHistory,
  cashOutList,
  cashOutViewDetails,
  cashOutViewDetailsHistory,
  allTransactionsList,
  refundList,
  refundViewDetails,
  settlementsHistory,
  settlementViewDetail,
  settlementViewSchedule,
  notesList,
  clientsList,
  clientViewDetails,
  clientViewHistory,
  merchantSettingsViewConfigRoles,
  merchantSettingsEditConfigGeneralLegalRoles,
  merchantSettingsEditLimitsRoles,
  merchantSettingsEditBanksDetailsRoles,
  ticketsList,
  ticketsDetails,
  recurringPaymentsList,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

const kycAbilities = [
  ...commonRoles,
  cashInList,
  cashInViewDetails,
  cashInViewDetailsHistory,
  cashOutList,
  cashOutViewDetails,
  cashOutViewDetailsHistory,
  allTransactionsList,
  refundList,
  refundViewDetails,
  settlementsHistory,
  settlementViewDetail,
  settlementViewSchedule,
  notesList,
  clientsList,
  clientViewDetails,
  clientViewHistory,
  merchantSettingsViewConfigRoles,
  merchantSettingsEditConfigGeneralLegalRoles,
  ticketsList,
  ticketsDetails,
  recurringPaymentsList,
  merchantSettingsEditBanksDetailsRoles,
  merchantSettingsViewBankDetailsRoles,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

const fraudRisksAbilities = [
  ...commonRoles,
  cashInList,
  cashInViewDetails,
  cashInViewDetailsHistory,
  cashOutList,
  cashOutViewDetails,
  cashOutViewDetailsHistory,
  allTransactionsList,
  refundList,
  refundViewDetails,
  settlementsHistory,
  settlementViewDetail,
  settlementViewSchedule,
  notesList,
  clientsList,
  clientViewDetails,
  clientViewHistory,
  merchantSettingsViewConfigRoles,
  merchantSettingsEditLimitsRoles,
  ticketsList,
  ticketsDetails,
  recurringPaymentsList,
  merchantSettingsViewBankDetailsRoles,
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
];

export const homeAbility = {
  login,
};

export const balanceAbility = {
  balancesUsable,
  balancesSettleable,
};

export const dashboardAbility = {
  paymentMethodsSummary,
  ticketsList,
  clientViewDetails,
  transferList,
  ...balanceAbility,
};

export const transactionsAbility = {
  cashInList,
  cashOutList,
  allTransactionsList,
  recurringPaymentsList,
};

export const cashInDetailsAbility = {
  cashInViewDetails,
  cashInResendNotification,
};

export const cashInFlagForReviewAbility = {
  cashInFlagForReview,
};

export const cashInManualRefundAbility = {
  cashInManualRefund,
};

export const cashInRequestManualAbility = {
  cashInRequestManual,
};

export const cashInDetailsHistoryAbility = {
  cashInViewDetailsHistory,
};

export const cashOutDetailsAbility = {
  cashOutViewDetails,
  cashOutResendNotification,
};

export const cashOutDetailsHistoryAbility = {
  cashOutViewDetailsHistory,
};

export const cashOutFlagForReviewAbility = {
  cashOutFlagForReview,
};

export const cashOutRequestReceiptAbility = {
  cashOutRequestReceipt,
};

export const cashOutRequestManualAbility = {
  cashOutRequestManual,
};

export const cashOutChangeStatusAbility = {
  cashOutChangeStatus,
};

export const settlementsHistoryAbility = {
  settlementsHistory,
  settlementsMerchant,
};

export const paymentOrderAbility = {
  paymentOrdersEnabled,
  paymentOrdersEnabledMerchant,
};

export const flagNoteForReviewAbility = {
  notesFlagForReview,
};

export const notesListAbility = {
  notesList,
  noteViewDetails,
  notesCreate,
};

export const refundsAbility = {
  refundList,
  refundViewDetails,
  refundCancel,
};

export const chargebacksAbility = {
  chargebackList,
};

export const balanceReportListAbility = {
  balanceReportList,
};

export const topUpAbility = {
  topUpList,
  topUpListMerchant,
};

export const topUpCreateAbility = {
  topUpCreate,
};

export const upcomingPaymentsAbility = {
  upcomingPaymentsList,
};

export const referralAbility = {
  referralReferredList,
  referralEditFee,
};

export const settlementDetailAbility = {
  settlementViewDetail,
  settlementAction,
};

export const settlementsRequestAbility = {
  settlementsRequest,
};

export const settingsAbility = {
  merchantSettingsViewConfigRoles,
  settlementViewSchedule,
  settlementUpdateSchedule,
};

export const clientsAbility = {
  clientsList,
};
export const clientsDetailsAbility = {
  clientViewDetails,
};
export const clientsDetailsHistoryAbility = {
  clientViewHistory,
};
export const clientsStatusChangeAbility = {
  clientStatusChange,
};
export const clientsLimitIncreaseAbility = {
  clientLimitIncrease,
};
export const paymentMethodsAbility = {
  paymentMethodsList,
  paymentMethodsStatus,
};
export const messageAbility = {
  messageList,
};

export const signupRequestUpdateAbility = {
  signupUpdateStatus,
  signupUpdateStatusCommercial,
};

export const rollingReserveAbilty = {
  rollingReserveView,
};

export const merchantsAbility = {
  merchantsList,
  merchantSettings,
  signUpRequestsList,
};
export const merchantSelfSettingsAbility = {
  merchantSettingsViewCompany,
  merchantSettingsEditCompany,
  merchantSettingsViewBankDetails,
  merchantSettingsViewSupportAddress,
  merchantSettingsEditSupportAddress,
  merchantSettingsViewIntegration,
  merchantSettingsViewSecretKey,
  merchantSettingsEditIntegration,
};
const merchantSettingsCompanyAbility = {
  merchantSettingsViewCompany,
  merchantSettingsEditCompany,
  merchantSettingsViewCompanyRoles,
  merchantSettingsEditCompanyRoles,
};
const merchantSettingsBanksDetailsAbility = {
  merchantSettingsViewBankDetails,
  merchantSettingsRequestChangeBank,
  merchantSettingsEditBanksDetails,
  merchantSettingsEditBanksDetailsRoles,
};

const merchantSettingsSupportAddressAbility = {
  merchantSettingsViewSupportAddress,
  merchantSettingsEditSupportAddress,
  merchantSettingsViewSupportAddressRoles,
  merchantSettingsEditSupportAddressRoles,
};

const merchantSettingsIntegrationsAbility = {
  merchantSettingsViewIntegration,
  merchantSettingsViewSecretKey,
  merchantSettingsEditIntegration,
  merchantSettingsViewIntegrationRoles,
  merchantSettingsViewSecretKeyRoles,
  merchantSettingsEditIntegrationRoles,
};

export const merchantSettlementScheduleAbility = {
  settlementViewSchedule,
  settlementUpdateSchedule,
};

export const merchantSettingsAbility = {
  ...merchantSettingsCompanyAbility,
  ...merchantSettingsBanksDetailsAbility,
  ...merchantSettingsSupportAddressAbility,
  ...merchantSettingsIntegrationsAbility,
  ...merchantSettlementScheduleAbility,
  merchantSettingsViewBalanceRoles,
  merchantSettingsViewConfigRoles,
  merchantSettingsEditConfigRoles,
  merchantSettingsEditLimitsRoles,
  merchantSettingsEditConfigGeneralRoles,
  merchantSettingsEditConfigGeneralLegalRoles,
  merchantSettingsEditConfigGeneralCommercialRoles,
  merchantSettingsViewMailGroups,
  merchantSettingsEditMailGroups,
  merchantSettingsViewIps,
  merchantSettingsEditIps,
  merchantSettingsChargebackConfig,
};

export const merchantSettingsMailGroupAbility = {
  merchantSettingsViewMailGroups,
  merchantSettingsEditMailGroups,
};

export const merchantSettingsCardPaymentConfigEditAbility = {
  merchantSettingsCardPaymentConfigEdit,
};

export const notificationsAbility = {
  notificationsList,
  notificationsCreate,
};

export const supportAbility = {
  createTicket,
  ticketsList,
  ticketsDetails,
  ticketsClose,
};

export const accountsAbility = {
  accountsList,
  accountsAdmin,
};

export const accountCreateAbility = {
  accountCreate,
  accountCreateAdmin,
};

export const accountEditAbility = {
  accountCreate,
  accountCreateAdmin,
  accountcommercialCanEditUsers,
};

export const exportTransactionsAbility = {
  exportTransactions,
};

export const beneficiariesAbility = {
  beneficiariesList,
  beneficiaryViewDetails,
  beneficiaryModify,
};

export const recurringPaymentsAbility = {
  recurringPaymentsList,
  recurringPaymentsViewDetails,
  recurringPaymentsModify,
};

export const batchCreationAbility = {
  cashOutListBatch,
  cashOutRequestBatch,
  cashOutDownloadBatch,
};

export const cashoutBatchAbility = {
  cashOutRequestBatch,
};

export const transferAbility = {
  transferList,
  transferCreate,
};

export const integrationAprovedAbility = {
  signupUpdateStatusIt,
};

export const cashOutResendNotificationAbility = {
  cashOutResendNotification,
};

export const authusAbility = {
  authusView,
};

export const explodeAbility = (capability) => {
  if (capability instanceof Capability) return capability;
  const capabilitySplitted = capability.toLowerCase().split('_').reverse();
  let subject = capitalize(capabilitySplitted.pop());
  if (twoPop.filter((d) => capability.includes(d)).length) {
    subject = `${subject}${capabilitySplitted.pop()}`;
  }
  const action = capabilitySplitted.reverse().join('_').toLowerCase() || 'execute';
  return new Capability(subject, action);
};

export const implodeAbility = (capability) => {
  if (capability instanceof Capability) return [capability.subject, capability.action].join('_').toUpperCase();
  return capability;
};

const roleCapabilities = {
  [userRoles.KYC]: kycAbilities.map((c) => implodeAbility(c)),
  [userRoles.ADMIN]: adminAbilities.map((c) => implodeAbility(c)),
  [userRoles.FINANCE]: financeAbilities.map((c) => implodeAbility(c)),
  [userRoles.COMMERCIAL]: commercialAbilities.map((c) => implodeAbility(c)),
  [userRoles.SUPPORT]: supportAbilities.map((c) => implodeAbility(c)),
  [userRoles.SUPPORT_ADMIN]: supportAdminAbilities.map((c) => implodeAbility(c)),
  [userRoles.LEGAL]: legalAbilities.map((c) => implodeAbility(c)),
  [userRoles.OPERATIONS]: operationsAbilities.map((c) => implodeAbility(c)),
  [userRoles.OPERATIONS_ADMIN]: operationsAdminAbilities.map((c) => implodeAbility(c)),
  [userRoles.IT]: itAbilities.map((c) => implodeAbility(c)),
  [userRoles.AUDIT]: auditAbilities.map((c) => implodeAbility(c)),
  [userRoles.COMPLIANCE]: complianceAbilities.map((c) => implodeAbility(c)),
  [userRoles.FRAUD_RISK]: fraudRisksAbilities.map((c) => implodeAbility(c)),
};

export const getCapabilitiesByRoles = (roles) => {
  return roles.reduce((before, rol) => (Object.keys(roleCapabilities).includes(rol) ? [...before, ...roleCapabilities[rol]] : before), []);
};

export const checkAllowedCapabilities = (capabilities) => {
  if (!capabilities) return false;
  let allow = false;
  if (capabilities instanceof Capability) {
    allow = Ability.can(capabilities.action, capabilities.subject);
  } else {
    allow = Object.values(capabilities).some((capability) => Ability.can(capability.action, capability.subject));
  }
  return allow;
};

/**
 * Set User abilities to context of casl
 */
export const setUserAbilities = (capabilities) => {
  Ability.update(capabilities.map((capability) => explodeAbility(capability)));
};

export const isInvalidCapabilityTupay = (capability) => {
  return TUPAY_INVALID_CAPABILITIES.some((invalid) => invalid.subject === capability.subject && invalid.action === capability.action);
};

/**
 * Set User abilities in component, with access to the store
 * @param state
 */
export const setUserAbilitiesByState = (state) => {
  const authCapabilities = getAuthCapabilities(state) || [];
  const UserDataCapabilities = getUserDataCapabilities(state) || [];
  //TODO Remove when the refactor is done
  if (isPanelType(PanelType.TUPAY)) {
    setUserAbilities([...authCapabilities, ...UserDataCapabilities]);
  } else {
    setUserAbilities([...authCapabilities]);
  }
};
